export default __webpack_public_path__ + "static/media/home-events-conference-img-05.2c754653.jpg";